import React from "react"
import { Visible } from 'AtomicComponents'
import componentParser from "AtomicUtils/componentParser"
import { IS_IFRAME } from 'AtomicUtils/environment'
import cookieHandler from "AtomicUtils/cookieHandler"

class PersonalisationBlockItem extends React.PureComponent {

  render() {
    const {
      iFrameOptions='showInBoth',
      mobile=false,
      desktop=false,
      tablet=false,
      urlList=null,
      components=[]
    } = this.props

    let cookieHandlerObject = new cookieHandler();
    let history = cookieHandlerObject.getCookie("history");
    if (history){
      let newHistory = JSON.parse(history)

      if (urlList && urlList.length > 0 && newHistory && newHistory.length > 0){
        let found = false;
        newHistory.map((item)=>{
          if (urlList.includes(item)){
            found = true
          }
        })
        if (!found) return (<div />)
      }
    }

    // iFrameOptions true means, do not show it in iFrame
    if (iFrameOptions === 'showInIframe' && !IS_IFRAME) return (<div />)
    if (iFrameOptions === 'hideInIframe' && IS_IFRAME) return (<div />)

    // visibility of block in different sizes
    let visibleArray = []
    if (desktop) visibleArray.push('screen')

    if (tablet) visibleArray.push('tablet')

    if (mobile) visibleArray.push('mobile')

    if (visibleArray.length === 0) return (<div />)

    return (
      <div style={{ width: "100%" }}>
        <Visible visible={visibleArray}>
          {components && components.length > 0 && componentParser(components)}
        </Visible>
      </div>
    )
  }
}


export default PersonalisationBlockItem



// WEBPACK FOOTER //
// ./src/AtomicComponents/PersonalisationBlockItem/PersonalisationBlockItem.jsx